<template>
  <div>
    <v-autocomplete
      label="Mitarbeiter"
      name="user"
      ref="userSelectbox"
      v-bind="$attrs"
      v-model="selected"
      :search-input.sync="searchUsers"
      :loading="loading"
      :items="usersList"
      :value="value"
      return-object
    >
      <template v-slot:append-outer>
        <v-chip small dense>
          {{ usersList ? usersList.length : 0 }}
        </v-chip>
      </template>
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>
            Mitarbeiter zum suchen eingeben
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content v-if="item.value.email">
          <v-list-item-title
            >{{ item.value.firstname }}
            {{ item.value.lastname }}</v-list-item-title
          >
          <v-list-item-subtitle>{{ item.value.email }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content v-else>
          <v-list-item-title>Alle</v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: "UserSelectbox",
  props: ["value", "showAll"],
  /*props: {
    value: {
      type: [Object, String],
      required: true,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
  },*/
  data: () => ({
    initial: false,
    selected: { text: "Alle", value: "all" },
    loading: false,
    searchUsers: null,
    usersList: []
  }),
  computed: {
    users() {
      return this.$store.getters["user/getUserList"];
    }
  },
  methods: {
    loadUsers() {
      let foundItems = [];
      if (this.showAll) {
        foundItems.push({ text: "Alle", value: "all" });
      }

      this.users.forEach(item => {
        foundItems.push({
          text: item.firstname + " " + item.lastname,
          value: item
        });
      });
      this.usersList = foundItems;
    },
    updateSelected(val) {
      if (!val) {
        return false;
      } else if (val === "all") {
        this.selected = this.usersList[0];
      }

      //  console.log("search", val, this.usersList);
      let foundIndex = this.usersList.findIndex(el => el.value._id == val._id);
      // console.log("found", foundIndex);
      if (foundIndex >= 0) {
        this.selected = this.usersList[foundIndex];
      } else {
        //this.usersList = [{ text: val.name, value: val }];
        this.selected = { text: val.name, value: val };
      }
    }
  },

  watch: {
    users() {
      this.loadUsers();
    },
    value(val) {
      this.updateSelected(val);
    },
    selected(value) {
      if (value === "all") {
        this.$emit("input", value);
      } else {
        this.$emit("input", value ? value.value : null);
      }
    },

    searchUsers() {
      /*  if (this.showAll && name === "Alle") {
        return false;
      }
      if ((name && name.length < 3) || this.initial) {
        return;
      }
      /*
      if (name && (!this.selected || this.selected.text !== name)) {
        this.loading = true;
        let foundItems = [];
        CustomerService.findByName(name)
          .then((result) => {
            result.data.data.forEach((item) => {
              foundItems.push({ text: item.name, value: item });
            });
          })
          .catch((error) => {
            foundItems = [];
            if (error.response.status != 401) {
              this.$notify({
                group: "dataline",
                type: "error",
                title: "Fehler",
                text: error.message,
              });
            }
          })
          .finally(() => {
            this.loading = false;
            this.customersList = foundItems;
          });
      }*/
    }
  },
  created() {
    this.loadUsers();
    this.updateSelected(this.value);
  }
};
</script>
